import { ID } from '@datorama/akita';
import { Column, Entity } from '../entity';
import { IEntity } from '../interfaces/models';
import { ColumnType, LanguagePage, PageTitles } from '../interfaces/types';

/**
 * CPMS User Context Interfaces
 * Represents the user's organization, outlets, and sales rep information from CPMS
 * Retrieved from: GET /v1/cpms/username/{username}
 */

export interface CPMSUserInfoSalesRep {
  salesRepPin: string;
  salesRepId: string;
  firstName: string;
  lastName: string;
  activeInd: boolean;
  jobTitleId: string;
}

export interface CPMSUserInfoPortalUser {
  portalRoleId: string;
}

export interface CPMSUserInfoOutletAssociation {
  outletId: number;
  nccsDealerCode: string;
  outletDes: string;
}

export interface CPMSUserInfoChannelOrg {
  chnlOrgId: number;
  chnlOrgCd: string;
  chnlOrgLegalName: string;
  chnlOrgDes: string;
  adminRegionId: string | null;
}

export interface CPMSUserInfo {
  salesRep: CPMSUserInfoSalesRep;
  portalUser: CPMSUserInfoPortalUser;
  salesRepOutletAssociations: CPMSUserInfoOutletAssociation[];
  channelOrg: CPMSUserInfoChannelOrg;
  peerGroup: string;
}

/**
 * CPMS Sales Rep Interface (for table display)
 */
export interface ICPMSSalesRep extends IEntity {
  salesRepPin: string;
  firstName: string;
  lastName: string;
  activeInd: string;
  outletId: number;
}

@Entity({
  name: PageTitles.cpmsSalesRep,
  language: LanguagePage.cpmsSalesRep,
})
export class CPMSSalesRep implements ICPMSSalesRep {
  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 1,
    },
  })
  salesRepPin: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 2,
    },
  })
  firstName: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 3,
    },
  })
  lastName: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 4,
    },
  })
  activeInd: string;

  id: ID;
  outletId: number;

  constructor(rep: ICPMSSalesRep) {
    this.id = rep.id;
    this.salesRepPin = rep.salesRepPin;
    this.firstName = rep.firstName;
    this.lastName = rep.lastName;
    this.activeInd = rep.activeInd;
    this.outletId = rep.outletId;
  }
}
